export function formatTimeAgo(dateString: string): string {
    if (!dateString) return '';
    
    // 날짜 문자열을 Date 객체로 변환
    const date = new Date(dateString);
    const now = new Date();
    
    // 시간 차이 (밀리초)
    const diff = now.getTime() - date.getTime();
    
    // 초, 분, 시간, 일, 주, 월, 년 단위로 변환
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);
    
    // 적절한 단위 반환
    if (seconds < 60) {
      return `${seconds}초 전`;
    } else if (minutes < 60) {
      return `${minutes}분 전`;
    } else if (hours < 24) {
      return `${hours}시간 전`;
    } else if (days < 7) {
      return `${days}일 전`;
    } else if (days < 30) {
      return `${Math.floor(days / 7)}주 전`;
    } else if (months < 12) {
      return `${months}개월 전`;
    } else {
      return `${years}년 전`;
    }
}
export function isEmpty(obj: any): boolean {
    if (obj == null) return true
    if (typeof obj === 'string' && obj.trim().length === 0) return true
    if (Array.isArray(obj) && obj.length === 0) return true
    if (typeof obj === 'object' && Object.keys(obj).length === 0) return true
    return false
}

export async function convertBlobToPng(blob: Blob): Promise<Blob> {
  return new Promise((resolve, reject) => {
    // 이미지가 이미 PNG인지 확인
    if (blob.type === 'image/png') {
      resolve(blob);
      return;
    }

    // Blob URL 생성
    const url = URL.createObjectURL(blob);
    const img = new Image();
    
    img.onload = () => {
      // 이미지 로드 완료 후 캔버스에 그리기
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas 컨텍스트를 생성할 수 없습니다.'));
        return;
      }
      
      // 이미지를 캔버스에 그리기
      ctx.drawImage(img, 0, 0);
      
      // 캔버스를 PNG Blob으로 변환
      canvas.toBlob((pngBlob) => {
        if (pngBlob) {
          resolve(pngBlob);
        } else {
          reject(new Error('PNG Blob 생성에 실패했습니다.'));
        }
        
        // 메모리 누수 방지
        URL.revokeObjectURL(url);
      }, 'image/png');
    };
    
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('이미지 로드에 실패했습니다.'));
    };
    
    img.src = url;
  });
}

export const mmToPx = (mm: number) => mm * (96 / 25.4)

export const calculateImageSize = (imageUrl: string, fixedHeightMM: number, offsetScale: number): Promise<{width: number, height: number}> => {
  return new Promise((resolve) => {
    const img = new Image();
    
    img.onload = () => {
      // 원본 이미지 비율 계산
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      
      // 고정된 높이값 (mm) 픽셀로 변환
      const fixedHeight = mmToPx(fixedHeightMM) * offsetScale;
      
      // 너비를 비율에 맞게 계산
      const calculatedWidth = fixedHeight * aspectRatio;
      
      resolve({
        width: calculatedWidth,
        height: fixedHeight
      });
    };
    
    img.onerror = () => {
      // 오류 발생시 기본값 반환
      const defaultHeight = mmToPx(fixedHeightMM) * offsetScale;
      resolve({
        width: defaultHeight, // 1:1 비율로 기본값 설정
        height: defaultHeight
      });
    };
    
    img.src = imageUrl;
  });
};